module.exports = {
  siteName: 'EthQuest',
  contact: {
    email: 'info@EthQuest.io',
    twitter: '@EthQuest',
  },
};
